import script from "./AppToolBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppToolBar.vue?vue&type=script&lang=ts&setup=true"

import "./AppToolBar.vue?vue&type=style&index=0&id=34dc7935&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34dc7935"]])

export default __exports__